import React from "react";
import styled from "styled-components";
import { GetMoneyValue } from "../../../../../Api/ApiCommon";
import { TableBodyItem } from "../../../../Table/Table";
import { PayInfoDetailProps } from "../PayInfoDetail";
import { getLPointShowValue } from "../../../../../ApiTS/ApiCommonTS";

export default function PartyFeePay({ data }: PayInfoDetailProps) {
  
  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>파티 요금</PayDetailItemText>
        <>
          <PayDetailItemChildText>파티 분담금</PayDetailItemChildText>
          <PayDetailItemChildText>링키드 수수료</PayDetailItemChildText>
        </>
        {(data?.logdata?.deposit ?? data?.log?.deposit) > 0 && (
          <PayDetailItemText>파티 보증금</PayDetailItemText>
        )}
        {(data?.logdata?.coupon ?? data?.log?.coupon) > 0 && (
          <PayDetailItemText>쿠폰 혜택</PayDetailItemText>
        )}
        
        {data?.log?.point > 0 && (
          <PayDetailItemText>링키드 포인트 사용</PayDetailItemText>
        )}
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 파티 요금 */}
        <PayDetailItemText>
          {GetMoneyValue(
            (data?.logdata?.amount ?? data?.log?.amount) -
              (data?.logdata?.deposit ?? data?.log?.deposit ?? 0),
          )}
        </PayDetailItemText>

        <>
          {/* 파티 분담금 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(
              (data?.logdata?.amount ?? data?.log?.amount) -
                (data?.logdata?.deposit ?? data?.log?.deposit ?? 0) -
                (data?.logdata?.comm ?? data?.log?.comm ?? 0),
            )}
          </PayDetailItemGrayText>
          {/* 링키드 수수료 */}
          <PayDetailItemGrayText>
            {GetMoneyValue(data?.logdata?.comm ?? data?.log?.comm ?? 0)}
          </PayDetailItemGrayText>
        </>

        {/* 파티 보증금 */}
        {(data?.logdata?.deposit ?? data?.log?.deposit) > 0 && (
          <PayDetailItemText>
            {GetMoneyValue(data?.logdata?.deposit ?? data?.log?.deposit)}
          </PayDetailItemText>
        )}

        {/* 쿠폰 혜택 */}
        {(data?.logdata?.coupon ?? data?.log?.coupon) > 0 && (
          <PayDetailItemText>
            -{GetMoneyValue(data?.logdata?.coupon ?? data?.log?.coupon)}
          </PayDetailItemText>
        )}

        {data?.log?.point > 0 && (
          <PayDetailItemText>
            -{getLPointShowValue(data?.log?.point)}
          </PayDetailItemText>
        )}
      </PayDetailItem>
    </>
  );
}

export const PayDetailItem = styled(TableBodyItem)`
  padding: 9px 10px;
`;

export const PayDetailItemText = styled.div`
  height: 36px;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  line-height: 22.5px;
  text-align: left;
`;

export const PayDetailItemGrayText = styled(PayDetailItemText)`
  color: #858c97;
`;

export const PayDetailItemChildText = styled(PayDetailItemGrayText)`
  padding-left: 20px;
`;
